import React, { useState } from 'react';
import './addblog.css';
import { assets } from '../../../assets/assets.js';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export const AddBlog = () => {
  const url = process.env.REACT_APP_BASE_URL

  const [image, setImage] = useState(null);
  const navigate = useNavigate();

  const [data, setData] = useState({
    title: "",
    description: ""
  });

  const onChangeHandler = (e) => {
    const eName = e.target.name;
    const value = e.target.value;
    setData((data) => ({ ...data, [eName]: value }));
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
   

    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("description", data.description);

    // If an image was uploaded, append it to the FormData object
    if (image) {
      formData.append("image", image);
    }

    try {
      const response = await axios.post(`${url}/api/blog/add`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 10000, 
      });

      // console.log('Response:', response);
      if (response.data.success) {
        // Reset form fields if the submission is successful
        setData({
          title: "",
          description: ""
        });
        setImage(null);
        toast.success("Blog Added");
        navigate('/admin/dashboard/blog'); 
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      // console.error("Error submitting blog:", error);
      toast.error("An error occurred while submitting the blog.");
    }
  };

  return (
    <div className='add'>
      <form className='flex-col' onSubmit={onSubmitHandler}>
        <div className='add-product-name flex-col'>
          <p>Blog Title</p>
          <input
            onChange={onChangeHandler}
            value={data.title}
            type="text"
            name='title'
            placeholder='Type here'
          />
        </div>

        <div className="add-product-description flex-col">
          <p>Blog Description</p>
          <ReactQuill
            value={data.description}
            onChange={(value) => setData({ ...data, description: value })}
            modules={{
              toolbar: [
                [{ 'header': [1, 2, 3, 4, false] }], // Dropdown for H1, H2, H3, H4, and normal text
                ['bold', 'italic', 'underline', 'strike'], // Text styling
                ['blockquote', 'code-block'], // Block formatting
                [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Lists
                [{ 'indent': '-1' }, { 'indent': '+1' }], // Indentation
                [{ 'script': 'sub' }, { 'script': 'super' }], // Subscript/Superscript
                [{ 'align': [] }], // Text alignment
                ['link', 'image', 'video'], // Media
                [{ 'color': [] }, { 'background': [] }], // Text and background colors
                ['clean'], // Clear formatting
              ]
            }}
            placeholder="Write content here"
          />
        </div>

        <div className="add-image-upload flex-col">
          <p>Upload Image</p>
          <label htmlFor="image">
            <img
              src={image ? URL.createObjectURL(image) : assets.upload_area}
              alt="Preview"
            />
          </label>
          <input
            onChange={(e) => setImage(e.target.files[0])} 
            type="file"
            id="image"
            hidden
          />
        </div>

        <button type="submit" className='add-btn'>ADD</button>
        <Link to="/admin/dashboard/blog" className='add-btn'>Back</Link>
      </form>
    </div>
  );
};
